import React from 'react'
import { LinearProgress, Box, Typography } from '@mui/material';

export const PercentageBarLabel = ({ percentage, altura }) => {

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', overflow: "hidden" }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress sx={{height: altura, borderRadius: "0.3em"}} variant="determinate" value={percentage} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">{percentage}%</Typography>
                </Box>
            </Box>
        </>
    )
}
